<script>
  import { onMount } from 'svelte'
  import Header from './header.svelte'
  import HeaderImage from './header-image.svelte'
  import Category from './category.svelte'
  import SnowflakeCanvas from '../snowflake.svelte'
  import Footer from '../footer.svelte'

  export let year
  export let age
  export let apiUrl

  let promise = new Promise(() => {})

  async function getData() {
    try {
      const res = await fetch(`${apiUrl}/${year}`)
      const json = await res.json()
      if (res.ok) {
        return json
      } else {
        throw new Error(`Kunne ikke hente data for ${year}`)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const categoryTitles = {
    julekalender: 'Kanskje du så på denne <strong>julekalenderen</strong>?',
    duSaPa: 'Kanskje husker du?',
    saUt: 'Eller andre som lagde <strong>julestemning</strong>? De så sånn ut',
    julesanger: 'På radio kunne du høre denne <strong>julesangen</strong>',
    varmelding: 'Kanskje lurte du på om det ville bli en hvit jul',
    nyttarstale: 'Til nyttår hadde kongen dette å fortelle i talen sin',
    oyeblikk: 'Og dette skjedde også det året',
    godJul: 'Håper dette ga deg gode minner! <br/>Vi ønsker deg en god og fredfull jul!',
  }

  function prepareCategories(categories) {
    let imageCounter = 0
    let even
    const categoryFeed = Object.keys(categories).map((categoryKey) => {
      const category = categories[categoryKey]
      const nyttarsTitleHasOverride = category[0].nyttar?.title
      const categoryHasImage = category.find((it) => it.type === 'image')
      if (categoryHasImage) {
        if (imageCounter % 2 === 0) {
          even = true
        } else {
          even = false
        }
        imageCounter++
      }
      return {
        categoryType: categoryKey,
        title: nyttarsTitleHasOverride ? category[0].nyttar.title : categoryTitles[categoryKey],
        even,
        content: category,
        useTextAsLink: categoryKey === 'julekalender' || categoryKey === 'duSaPa',
      }
    })
    return categoryFeed
  }

  const decoration = [
    { name: 'kule', alternativeText: 'En julekule som henger i en gren med lys på', used: false },
    { name: 'presang', alternativeText: 'To presanger med julelys i bakgrunnen', used: false },
    {
      name: 'dompapp',
      alternativeText: 'En dompapp stående på en rognebærtregren med julelys i bakgrunnen',
      used: false,
    },
    {
      name: 'lys',
      alternativeText: 'Et tent stearinlys ved siden av en snøglobe med julelys i bakgrunnen',
      used: false,
    },
  ]

  function addDecoration(categories) {
    const categoriesWithDecoration = []
    for (let i = 0; i < categories.length; i++) {
      const row = i + 1
      categoriesWithDecoration.push(categories[i])
      if (row % 2 === 0) {
        const firstNotUsedDecoration = decoration.findIndex((it) => it.used === false)
        if (typeof firstNotUsedDecoration !== 'undefined') {
          decoration[firstNotUsedDecoration].used = true
          categoriesWithDecoration.push({
            title: '',
            categoryType: 'julepynt',
            content: [
              {
                type: 'julepynt',
                ...decoration[firstNotUsedDecoration],
              },
            ],
            even: true,
            useTextAsLink: false,
          })
        }
      }
    }
    return categoriesWithDecoration
  }

  onMount(async () => {
    if (typeof window !== 'undefined') {
      const data = await getData()
      const preparedCategories = prepareCategories(data)
      const addedDecorations = addDecoration(preparedCategories)
      promise = addedDecorations
    }
  })
</script>

<div class="wrapper">
  <div class="content">
    {#await promise then data}
      <HeaderImage image={data[0].content[0]} />
      <SnowflakeCanvas />
      <Header {year} {age} />
      {#each data.slice(1) as category}
        <Category
          text={category.title}
          data={category.content}
          pictureLeanTowards={category.even === true ? 'left' : 'right'}
          type={category.categoryType}
          useTextAsLink={category.useTextAsLink}
        />
      {/each}
    {/await}
  </div>
  <Footer showYearInput={true} />
</div>

<style>
  .wrapper {
    min-height: 100vh;
    width: 100vw;
    position: relative;
    z-index: 0;
    background-color: #0a2343;
    overflow: hidden;
  }

  .content {
    display: flex;
    padding-top: calc(100vw * 0.3);
    flex-direction: column;
    align-items: center;
    max-width: 600px;
    margin: 0 auto;
    width: calc(100vw - 30px);
    color: #fff;
    gap: 15px;

    @media screen and (min-width: 400px) {
      padding-top: calc(100vw * 0.2);
    }
    @media screen and (min-width: 1280px) {
      padding-top: 250px;
    }
  }
</style>
